export default __webpack_public_path__ + "static/media/loginEntryPointPost.1f665193.webp";